import { useEffect } from 'react';

// Hook for adding scroll-triggered animations
export const useScrollAnimation = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        // Observe all elements with animation classes
        const animatedElements = document.querySelectorAll(
            '.feature-card, .testimonial-card, .pricing-card, .step'
        );

        animatedElements.forEach(el => {
            observer.observe(el);
        });

        return () => {
            animatedElements.forEach(el => {
                observer.unobserve(el);
            });
        };
    }, []);
};

// Smooth scroll utility for navigation
export const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
};

// Add scroll-to-top functionality
export const ScrollToTop = () => {
    useEffect(() => {
        const scrollButton = document.createElement('button');
        scrollButton.innerHTML = '↑';
        scrollButton.className = 'scroll-to-top';
        scrollButton.setAttribute('aria-label', 'Scroll to top');
        
        scrollButton.style.cssText = `
            position: fixed;
            bottom: 2rem;
            right: 2rem;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: var(--brand-color);
            color: white;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
            z-index: 1000;
            box-shadow: 0 4px 15px rgba(9, 102, 255, 0.3);
        `;

        const handleScroll = () => {
            if (window.scrollY > 500) {
                scrollButton.style.opacity = '1';
                scrollButton.style.visibility = 'visible';
            } else {
                scrollButton.style.opacity = '0';
                scrollButton.style.visibility = 'hidden';
            }
        };

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        };

        scrollButton.addEventListener('click', scrollToTop);
        window.addEventListener('scroll', handleScroll);
        document.body.appendChild(scrollButton);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            scrollButton.removeEventListener('click', scrollToTop);
            if (document.body.contains(scrollButton)) {
                document.body.removeChild(scrollButton);
            }
        };
    }, []);

    return null;
};
